<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on:tooltip }">
          <v-btn
            icon
            v-on="{...dialog,...tooltip}"
          >
            <v-icon color="green">
              mdi-checkbook
            </v-icon>
          </v-btn>
        </template>
        <span v-if="payrollCycleTransaction.status=='COMPUTED'">Release / Email {{ payrollCycleTransaction.payroll_cycle.name }} Payslip</span>
        <span v-else>Email {{ payrollCycleTransaction.payroll_cycle.name }} Payslip</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      :title="'Release ' + payrollCycleTransaction.payroll_cycle.name + ' Payslip'"
      text="Payroll Cycle Employees"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row v-show="confirmationDialog">
            <v-col>
              <payroll-payroll-cycle-dialog-bonus-letter-date-selection
                ref="dialogBonusLetterDate"
                @released="closeDialog();loadData()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-card class="pa-4 elevation-5">
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="filteredHeaders"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  show-select
                  class="elevation-1 mb-3 cursor-pointer"
                  height="272px"
                  :error-messages="errors.collect('selectedEmployees')"
                  data-vv-name="selectedEmployees"
                  data-vv-as="employee selection"
                  @click:row="getDocument"
                >        
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar
                        flat
                        color="white"
                      >
                        <v-toolbar-title>Employee Selection:</v-toolbar-title>
                      </v-toolbar>
                      <v-col cols="5">
                        <div
                          class="mt-1 pr-1"
                          style="display: flex; justify-content: flex-end"
                        >
                          <v-switch
                            v-model="isPayslipSent"
                            label="Is Payslip Released"
                            @change="selectedEmployees = []"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                  
                  <template v-slot:item.is_payslip_sent="{ item }">
                    <v-icon medium>
                      {{ item.is_payslip_sent ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                    </v-icon>
                  </template>
                  
                  <template v-slot:item.payslip_sent_by_email="{ item }">
                    <v-icon medium>
                      {{ item.payslip_sent_by_email ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                    </v-icon>
                  </template>
                </v-data-table>
                
                <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                  <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
                </div>
              </v-card>
            </v-col>
            
            <v-col cols="4">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee"
                hide-no-data
                hide-selected
              />

              <v-autocomplete
                v-model="filters.companies"
                :items="companies"
                item-text="name"
                item-value="id"
                value="id"
                label="Companies"
                placeholder="Filter employee by company"
                clearable
                hide-selected
                multiple
                deletable-chips
                chips
              /> 

              <v-autocomplete
                v-model="defaultStatus"
                :items="statuses"
                item-text="name"
                item-value="value"
                value="value"
                label="Employment status"
                placeholder="Filter by employee status"
                clearable
                hide-selected
                multiple
                deletable-chips
                chips
                return-object
              /> 

              <v-card-actions style="position: absolute;bottom: 30px;right: 0px;">
                <v-spacer />
                <v-btn
                  :disabled="progressing"
                  @click="dialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  v-if="isPayslipSent"
                  :loading="progressing && isEmail"
                  :disabled="progressing && isWithdraw"
                  color="purple"
                  class="white--text px-3"
                  @click="validate"
                >
                  Email Payslip
                </v-btn>
                <v-btn
                  v-if="isPayslipSent && payrollCycleTransaction.status=='COMPUTED'"
                  :loading="progressing && isWithdraw"
                  :disabled="progressing && isEmail"
                  color="red"
                  class="white--text px-3"
                  @click="withdraw"
                >
                  Cancel Released Payslip
                </v-btn>
                <v-btn
                  v-if="!isPayslipSent && payrollCycleTransaction.status=='COMPUTED'"
                  :loading="progressing"
                  color="hrissecondary"
                  class="white--text px-10"
                  @click="submitForm"
                >
                  Release Payslip
                </v-btn>
              </v-card-actions>
              <payroll-dialog-email
                ref="showEmailWindow"
                :document-type="'Payslip'"
                @emailed="loadData();selectedEmployees = []"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      PayrollPayrollCycleDialogBonusLetterDateSelection: () => import('@/components/hris/payroll/payroll-cycle/DialogBonusLetterDateSelection'),
      PayrollDialogEmail: () => import('@/components/hris/payroll/DialogEmail'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriod: {
        type: Object,
        required: true,
      },
      payrollCycleTransaction: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        isWithdraw: false,
        isEmail: false,
        confirmationDialog: false,
        requestELetter: true,
        dialog: false,
        progressing: false,
        companies: [],
        employees: [],
        orderedEmployees: [],
        selectedEmployees: [],        
        switchEmployees: [],
        tableLoading: false,
        searchInput: '',
        empObj: null,
        isPayslipSent: 0,        
        filters: {
          companies: '',
        },
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company',
          }, 
          {
            text: 'Is Payslip Released',
            align: 'center',
            sortable: false,
            value: 'is_payslip_sent',
          },
        ],
        defaultStatus: [
          {
            name: 'Active',
            value: '1',
          },
          {
            name: 'Resigned',
            value: '0',
          },
        ],
        statuses: [
          {
            name: 'Active',
            value: '1',
          },
          {
            name: 'Resigned',
            value: '0',
          },
        ],
      }
    },

    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.switchEmployees.filter(function (employee) {
          return ((employee || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })

        if (this.defaultStatus.length === 0) return 
        
        if (this.defaultStatus.length === 1) {
          if (this.defaultStatus[0].value === '1') {
            primaryFilterEmployees = primaryFilterEmployees.filter(function (employee) {
              return !(employee || {}).end_date || (employee && employee.end_date && (new Date(employee.end_date) > new Date()))
            })
          } else {
            primaryFilterEmployees = primaryFilterEmployees.filter(function (employee) {
              return (employee && employee.end_date && (new Date(employee.end_date) <= new Date()))
            })
          }
        }

        let filteredCompanies = this.customFilterCompanies(primaryFilterEmployees)

        return filteredCompanies
      },
      filteredHeaders () {
        return this.isPayslipSent ? [...this.headers, {
          text: 'Email Payslip',
          align: 'center',
          sortable: false,
          value: 'payslip_sent_by_email',
        },
        ] : this.headers
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loadData()
      },
      isPayslipSent: {
        immediate: true,
        handler (value) {
          this.switchEmployees = []

          if (this.isPayslipSent) { 
            this.isPayslipSent = 1 
            
            this.switchEmployees = this.orderedEmployees.filter(emp => {
              return emp.is_payslip_sent === 1
            })
          } else { 
            this.isPayslipSent = 0
            
            this.switchEmployees = this.orderedEmployees.filter(emp => {
              return emp.is_payslip_sent === 0
            })
          }
        },
      },    
    }, 

    methods: { 
      closeDialog () {
        this.dialog = false
      },             
      loadData () {
        this.tableLoading = true
        this.orderedEmployees = []
        this.employees = []
        this.companies = []

        Promise.all([
          this.$api.payrollCycleTransactionCompanies().show(this.payrollCycleTransaction.id),
          this.$api.payrollCycleEmployees().show(this.payrollCycleTransaction.id),
        ]).then(([company, employee]) => {
          employee.data.map(emp => {
            this.empObj = {
              name: emp.employee.person.name,
              company_uid: emp.company.id,
              company: emp.company.name,
              company_employee_uid: emp.company_employee_uid,
              employee_uid: emp.employee_uid,
              end_date: emp.employee.end_date,
            }
            emp.payroll_cycle_employees.map(payrollCycleEmployee => {
              this.empObj.is_payslip_sent = payrollCycleEmployee.is_payslip_sent
              this.empObj.payslip_sent_by_email = payrollCycleEmployee.payslip_sent_by_email
            })
            this.employees.push(this.empObj)
          })
          this.orderedEmployees = _.orderBy(this.employees, ['is_payslip_sent', 'name', 'company'], ['asc', 'asc', 'asc'])
          this.companies = _.orderBy(company.data, ['name'], ['asc'])
          this.switchEmployees = this.orderedEmployees.filter(emp => {
            return emp.is_payslip_sent === this.isPayslipSent
          })
          this.tableLoading = false
        })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payslips().releasePayslip(this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'Payslip released successfully' })
                this.loadData()
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$refs.dialogBonusLetterDate.toggleDialog(this.prepareFormData())
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      withdraw () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.isWithdraw = true

            this.$api.payslips().withdrawPayslip(this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'Payslip withdrawn successfully' })
                this.loadData()
              })
              .catch((err) => {
                if (err.response.status === 422 && err.response.data.status) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                } else this.$snack({ color: 'error', message: 'Unable to withdraw sent payslip' })
              })
              .then(() => {
                this.progressing = false
                this.isWithdraw = false
              })
          })
      },
      validate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.$refs.showEmailWindow.toggleDialog(this.prepareSelectedEmployeesFormData())
          })
      },
      prepareFormData () {
        return {
          employees: this.selectedEmployees,
          payroll_period_id: this.payrollPeriod.id,
          payroll_cycle_transaction_id: this.payrollCycleTransaction.id,
          is_e_letter_sent: this.requestELetter,
        }
      },
      prepareSelectedEmployeesFormData () {
        return {
          payroll_cycle_transaction_id: this.payrollCycleTransaction.id,
          selectedCompanyEmployees: this.selectedEmployees,
        }
      },
      customFilterCompanies (transactions) {
        if (this.filters.companies.length === 0) return transactions

        return transactions.filter(transaction => {
          let companyUid = transaction.company_uid

          return _.intersection([companyUid], this.filters.companies).length > 0
        })
      },     
      getDocument (value) {
        this.$api.payslips().download(value.company_employee_uid, this.payrollCycleTransaction.id, 'view')
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('target', value.name + '(' + value.company + ')' + '.pdf') 
            link.click()
          })
      },       
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
.cursor-pointer >>> tr{
  cursor: pointer;
}
</style>
